import { cn } from '@/lib/utils';

import { Text } from '@/components/atoms/Text';

const PricingSectionRowSecondaryText = ({
  text,
  animateOnHover,
  isStatic,
  hasBadgeOfHonor,
}: {
  text: string;
  isStatic?: boolean;
  animateOnHover?: boolean;
  hasBadgeOfHonor?: boolean;
}) => {
  return (
    <Text
      classNames={{
        wrapper: cn(
          'text-body-s',
          hasBadgeOfHonor ? 'text-gray-dark-300' : 'text-gray-500',
          animateOnHover
            ? 'invisible opacity-0 group-hover/column:visible group-hover/column:opacity-100'
            : 'visible opacity-100',
          !animateOnHover && 'opacity-100',
          !isStatic &&
            'bottom-2 absolute left-1/2 -translate-x-1/2 transition-opacity duration-300',
          isStatic && 'text-body-m'
        ),
      }}
    >
      {text}
    </Text>
  );
};

export default PricingSectionRowSecondaryText;
